import React, { createContext, useContext } from 'react'

import { LoadingWithSpinner } from 'modules/finance/components/FinancialWorkspace/components/LoadingWithSpinner'
import {
  FWPermissions,
  usePermissions,
} from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/usePermissions'

interface Props {
  children: React.ReactNode
}

interface IValue {
  permissions: FWPermissions
  loading: boolean
}

const PermissionsProviderContext = createContext<IValue | undefined>(undefined)

export const PermissionsProvider: React.FC<Props> = ({ children }) => {
  const { permissions, loading } = usePermissions()

  if (loading) {
    return <LoadingWithSpinner />
  }

  return (
    <PermissionsProviderContext.Provider
      value={{
        permissions,
        loading,
      }}
    >
      {children}
    </PermissionsProviderContext.Provider>
  )
}

export const usePermissionsData = () => {
  const context = useContext(PermissionsProviderContext)
  if (context === undefined) {
    throw new Error('usePermissionsData must be used within a PermissionsProvider')
  }
  return context
}
